import { Box, Grid } from '@mui/material';

import { TextField, StatesSingleAutocomplete } from '@occc-app/design-system';

import { StoreAttributes } from './store-attributes.component';

export const StoreDetails = () => {
  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <TextField
            required
            label='Location name'
            name='details.name'
            type='text'
            margin='normal'
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField required label='Street 1' name='details.street1' type='text' margin='normal' />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField label='Street 2' name='details.street2' type='text' margin='normal' />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <TextField required label='City' name='details.city' type='text' margin='normal' />
        </Grid>

        <Grid item xs={12} md={4}>
          <StatesSingleAutocomplete
            name='details.state'
            label='State'
            inputProps={{ required: true, margin: 'normal' }}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField required label='Zip Code' name='details.zipCode' type='text' margin='normal' />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <TextField
            label='Site Phone Number'
            name='details.phoneNumber'
            type='text'
            margin='normal'
          />
        </Grid>

        <Grid item xs={12} alignItems='center'>
          <StoreAttributes />
        </Grid>
      </Grid>
    </Box>
  );
};
